import React from 'react';
import PropTypes from 'prop-types';
import DesktopNavigation from './DesktopNavigation';
import CustomPropTypes from '../../utils/customPropTypes';



export default class MainNavigation extends React.Component {

  static propTypes = {
    mainMenuItems: PropTypes.array,
    contactUrl: PropTypes.string,
    searchUrl: PropTypes.string,
  }

  static defaultProps = {
    mainMenuItems: [],
  }

  render() {
      return <DesktopNavigation {...this.props} />
  }

}
